import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import {Component,OnInit,Input,Output,EventEmitter} from '@angular/core';
import { NotificationService, GridDataSource,LoaderService, CONSTANT, ErrorService, EVENTO,TOOLTIPS, ICONS, ACTIONS, TYPEMESSAGE, UtilityService } from "../../../../shared/session/index";
import { Aplicacion,Iapplication } from "../shared/aplicacion.model";
import { AplicacionService} from "../shared/aplicacion.service";
import { RegularExpressionMessage, RegularExpression, CustomValidators } from '../../../../shared/validation/customvalidation';
@Component({
	//moduleId: module.id,
	selector: 'app-aplicacion-edit',
	templateUrl: 'aplicacion-edit.component.html'
})
export class ApplicationEditComponent implements OnInit {
  @Output() onChangeEvent: EventEmitter<any> = new EventEmitter();
  @Input() data: any;
  @Input() titlePage: string;
  // @Input()  ID:number;

  formGrupEditApplication: FormGroup;
  buttonGroup: any;
  aplicacion:Iapplication;
  nomApplicationMaxLength: number;
  msgErrorActualizar: string;
  msgErrorGet: string;
  obligatorioMsg: string;
  maxLengthMsg:number;
  descripcionMaxLength: number;
  nomAplicacionPatternMsg: string = RegularExpressionMessage.LETRAS_TILDE_ENIE_MSG;

  constructor(
    private loaderService: LoaderService,
    private aplicacionService: AplicacionService,
    private notificationService: NotificationService,
    private errorService: ErrorService,
    public fb: FormBuilder) {}

  ngOnInit(){
    this.buttonGroup = [
			{ tooltip: TOOLTIPS.save, icon: ICONS.save, action: ACTIONS.save }
    ];
    this.msgErrorActualizar = 'Error al actualizar datos';
    this.msgErrorGet = 'Error al obtener datos';
    this.aplicacion = new Aplicacion(0,"","","", "",true,"","","","");
    this.setValuesFormBuilder();
    this.obtenerAplicacion(this.data.aplicacion.ID);
  }

  private setValuesFormBuilder(){
    this.formGrupEditApplication = this.fb.group({
      Name: [this.aplicacion.Name,  Validators.compose([
        Validators.required,
        Validators.maxLength(this.nomApplicationMaxLength),
        CustomValidators.pattern(RegularExpression.LETRAS_TILDE_ENIE_NUMERO)
      ])],
      Path:[this.aplicacion.Path,  Validators.compose([
        Validators.required,
        Validators.maxLength(this.nomApplicationMaxLength),

      ])],
      Icono:[this.aplicacion.Icono,  Validators.compose([
        Validators.required,
        Validators.maxLength(this.nomApplicationMaxLength),

      ])],
      description: [this.aplicacion.Description,Validators.compose([
        Validators.maxLength(this.descripcionMaxLength),
        CustomValidators.pattern(RegularExpression.LETRAS_TILDE_ENIE_NUMERO)
      ])],
      status: [this.aplicacion.Status],

    });
  }

  formGrupEditApplicationSubmit(event){
    if (this.formGrupEditApplication.invalid)
      return;

    this.aplicacion.Name=event.value.Name
    this.aplicacion.Description = event.value.description;
    this.aplicacion.Path = event.value.Path;
    this.aplicacion.Icono=event.value.Icono;
    this.aplicacion.Status=event.value.status
    this.actualizarApplication(this.aplicacion);
  }

  private changeEvent(aplicacion:Iapplication) {
    this.data.aplicacion=aplicacion
    this.onChangeEvent.emit({ evento: EVENTO.consultar,data: this.data });
  }

  private actualizarApplication(aplicacion: Iapplication ) {
    this.loaderService.show();
    this.aplicacionService.actualizarApplication(aplicacion)

    .subscribe(res => {
        // if (this.errorService.getResultMessageError2(res)) {
            // this.data.access.status = aplicacion.Status;
            //this.notificationService.error(res.Data.mensaje, TYPEMESSAGE.Correcto);
            this.changeEvent(aplicacion);
        // }
    },
    error => {
        this.notificationService.error(this.msgErrorActualizar);
        throw error;
    },
    () => {
        this.loaderService.hide();
    });
  }

  private obtenerAplicacion(aplicacionID: number): void {
    this.loaderService.show();
    this.aplicacionService.obtenerApplication(aplicacionID)
    .subscribe(res => {
      this.aplicacion = res;
    },
    error => {
        this.notificationService.error(this.msgErrorGet);
        throw error;
    },
    () => {
        this.setValuesFormBuilder();
        this.loaderService.hide();
    });
  }
}
